import { ReactComponent as LogoIcon } from 'assets/img/almanac-logo-gradient-big.svg'
import { Button } from 'components/Button'
import { Modal } from 'common/Modal/Modal'

import Styles from './CopiedCoreTemplateModal.module.scss'
export interface CopiedCoreTemplateModalProps {
  close: () => void
}

const CopiedCoreTemplateModal = ({ close }: CopiedCoreTemplateModalProps) => (
  <Modal
    show
    onClose={close}
    headerClassName={Styles.header}
    wrapperClassName={Styles.wrapper}
    showCloseIcon={false}
    withGradient
  >
    <div className={Styles.title}>
      <LogoIcon />
      <span>Work Faster.</span>
    </div>

    <div className={Styles.info}>Here's a copy of the template you were viewing. Happy writing!</div>
    <div className={Styles.button}>
      <Button size="lg" onPress={close}>
        Get Started
      </Button>
    </div>
  </Modal>
)

export default CopiedCoreTemplateModal
